import React from 'react';

import classNames from 'classnames';

import { serializerFlexAlignment } from '../../utils/serializerFlexAlignment';

import type { Tag, TagsCardSchema, TTagsAttributes } from '../Tags.types';
import Description from './Description';
import Name from './Name';

const cardSchema: TagsCardSchema = {
  node: 'div',
  className: 'flex flex-col gap-2',
  children: [
    {
      node: 'name',
      className: '',
      children: [],
    },
    {
      node: 'description',
      className: '',
      children: [],
    },
  ],
};

interface SerializerProps {
  tag: Tag;
  attributes: TTagsAttributes;
}

// In the future we're going to want to add image support here, hence the Serializer.
// We will want to be able to handle multiple different card structures.
const Serializer: React.FC<SerializerProps> = ({ tag, attributes }) => {
  const renderNode = (node: TagsCardSchema): React.ReactNode => {
    switch (node.node) {
      case 'div': {
        const flexAlignmentClass = serializerFlexAlignment({
          alignment: attributes?.alignment || ('left' as any),
          includesFlexRow: node.className.includes('flex-row'),
          includesFlexColumn: node.className.includes('flex-col'),
        });

        return (
          <div className={classNames(node.className, flexAlignmentClass)}>
            {node.children.map((child, index) => (
              <React.Fragment key={index}>{renderNode(child)}</React.Fragment>
            ))}
          </div>
        );
      }
      case 'name':
        return <Name className={classNames(node.className)} name={tag?.display} attributes={attributes} />;
      case 'description':
        return attributes?.descriptionEnabled ? (
          <Description className={classNames(node.className)} description={tag?.description} attributes={attributes} />
        ) : null;
      default:
        return null;
    }
  };

  return <>{renderNode(attributes?.cardStructure || cardSchema)}</>;
};

export default Serializer;
